export function Photo({
    inputData,
}) {
    return (
        <div className="invitation" id="invitation-print-area">
            <div className={`invite-card-${inputData.theme}`}>

                <div className="photo"></div>

                <h1>{inputData.title}</h1>
                <div className="age">{inputData.event}</div>

                <div className={`invite-details-${inputData.theme}`}>
                    <p><span>Date:</span> {new Date(inputData.date).toDateString()}</p>
                    <p><span>Time:</span> {inputData.time}</p>
                    <p><span>Venue:</span> {inputData.venue}</p>
                </div>
                <footer>{inputData.footer}</footer>
            </div>
        </div>
    );
}